import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { changePassword } from "@/lib/api";
import { toast } from "sonner";

export default function ChangePasswordDialog() {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [nw2, setNw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nw !== nw2) return toast.error("Le due password nuove non coincidono");
    setBusy(true);
    try {
      await changePassword(cur, nw);
      toast.success("Password aggiornata: dal prossimo accesso usa quella nuova");
      setOpen(false); setCur(""); setNw(""); setNw2("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Cambio password non riuscito");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-testid="change-password-button" variant="ghost" size="sm" className="gap-2 text-slate-300 hover:text-white">
          <KeyRound className="h-4 w-4" /> <span className="hidden sm:inline">Password</span>
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-slate-900 border-white/10 text-white sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display">Cambia password</DialogTitle>
          <DialogDescription className="text-slate-400">Minimo 8 caratteri. Google Authenticator resta attivo.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Input data-testid="pwd-current" type="password" required placeholder="Password attuale" value={cur} autoComplete="current-password"
            onChange={(e) => setCur(e.target.value)} className="bg-slate-950 border-white/10 text-white" />
          <Input data-testid="pwd-new" type="password" required minLength={8} placeholder="Nuova password" value={nw} autoComplete="new-password"
            onChange={(e) => setNw(e.target.value)} className="bg-slate-950 border-white/10 text-white" />
          <Input data-testid="pwd-new2" type="password" required minLength={8} placeholder="Ripeti nuova password" value={nw2} autoComplete="new-password"
            onChange={(e) => setNw2(e.target.value)} className="bg-slate-950 border-white/10 text-white" />
          <Button data-testid="pwd-submit" type="submit" disabled={busy} className="w-full gap-2 bg-accent hover:bg-accent/90 text-white">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />} Salva nuova password
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
